import DynamicForm from "@components/DynamicForm/DynamicForm";
import { UIFormField } from "@components/DynamicForm/types";
import DocumentMonoIcon from "@icons/DocumentMonoIcon";
import { useUserStore } from "@providers/auth";
import { useEffect, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { usePaymentStore } from "../../../payment";
import CheckoutSectionWrapper from "./CheckoutSectionWrapper";

const _t = (key: string) => key;

const CheckoutBillingForm = ({
  fields,
  onChange: onChange = () => {},
  onValidChange: onValidChange = () => {},
}: {
  fields: UIFormField[];
  onChange: (values: FieldValues) => void;
  onValidChange: (valid: boolean) => void;
}) => {
  const user = useUserStore((state) => state.user);
  const transaction = usePaymentStore((state) => state.transaction);
  const [initialized, setInitialized] = useState(false);

  const {
    handleSubmit,
    register,
    formState: { errors, isValid, isDirty },
    setValue,
    getValues,
    watch,
    trigger,
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    onValidChange(isValid);
  }, [isValid]);

  useEffect(() => {
    const subscription = watch(async () => {
      trigger();
      onChange(getValues());
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  // prefill contact info if available
  useEffect(() => {
    if (!transaction || !user || initialized) return;
    setInitialized(true);
    const email = transaction.contact.email || user.email || "";
    setValue("email", email);
    const name =
      transaction.items.find((item) => item.contact.email === email)?.contact
        .name ||
      transaction.contact.name ||
      "";
    setValue("name", name);
  }, [
    user?.email,
    transaction?.contact.email,
    transaction?.contact.name,
    initialized,
  ]);

  return (
    <CheckoutSectionWrapper
      isDirty={isDirty}
      isValid={isValid}
      title={_t("Billing Information")}
      icon={DocumentMonoIcon}
    >
      <DynamicForm
        fields={fields}
        errors={errors}
        register={register}
        handleSubmit={handleSubmit}
        isDirty={isDirty}
      />
    </CheckoutSectionWrapper>
  );
};

export default CheckoutBillingForm;
